import * as ko from "knockout";
import {lm} from "../appContext";
import {isNullOrUndefined} from "./misc";
import {storeObservable} from "./sessionstore";
import {nsLanguage} from "./nsLanguage";

export namespace nsBadge {
    export type TBadgeValue = string | number;
    export type TBadgeObject = {value: TBadgeValue, cls?: string}

    export function getValue(badge: KnockoutObservable<TBadgeValue|TBadgeObject|null>): TBadgeValue | null {
        storeObservable('language')().key
        const ret = ko.unwrap(badge);
        if (isNullOrUndefined(ret)) {
            return null;
        }
        if (typeof ret === 'number') {
            return nsLanguage.toLocaleString(ret)
        }
        if (typeof ret === 'string') {
            if (ret.startsWith('<')) {
                return ret
            } else {
                return lm.t(ret)
            }
        }
        if (typeof ret === 'object' && ret) {
            return `<span class="${ret.cls ?? ''}">${lm.t(String(ret.value)) ?? ''}</span>`
        }
        return ret;
    }

    function formatValue(val: TBadgeValue): string {
        const lang = storeObservable('language')()
        if (Number.isInteger(val)) {
            return nsLanguage.toLocaleString(Number(val))
        }
        return String(val);
    }
}